export interface SeedPrSummary {
  advisorLabel: string;
  version: string;
  notesUrl: string | null;
  repo: string;
  updated: string[];
  added: string[];
  deleted: string[];
  skipped: { path: string; skipReason: string }[];
}

export function composeSeedPrTitle(s: SeedPrSummary): string {
  return `Update your ${s.advisorLabel}'s built-in skills & guides (${s.version})`;
}

const basename = (p: string): string => p.split("/").filter(Boolean).slice(-2).join("/");

export function composeSeedPrBody(s: SeedPrSummary): string {
  const lines: string[] = [];
  lines.push(`This refreshes the skills and reference guides that came built into your ${s.advisorLabel}, bringing them up to date with platform release **${s.version}**.`);
  lines.push("");
  if (s.updated.length || s.added.length || s.deleted.length) {
    lines.push("**What changed**");
    if (s.updated.length) lines.push(`- ✏️ Updated ${s.updated.length.toString()}: ${s.updated.map(basename).join(", ")}`);
    if (s.added.length) lines.push(`- ➕ Added ${s.added.length.toString()}: ${s.added.map(basename).join(", ")}`);
    if (s.deleted.length) lines.push(`- 🗑️ Removed ${s.deleted.length.toString()}: ${s.deleted.map(basename).join(", ")}`);
    lines.push("");
  }
  lines.push("**Your own content is untouched.** Only built-in files change here — nothing you or your advisor wrote (your memory, your inbox, skills your advisor learned on its own) is modified.");
  if (s.skipped.length) {
    lines.push("");
    lines.push(`**${s.skipped.length.toString()} file(s) were left as-is** because you've customized them and we won't overwrite your edits. To take an update anyway, open that file in the latest release and copy the changes over by hand:`);
    for (const sk of s.skipped) lines.push(`- \`${sk.path}\` — ${sk.skipReason}`);
  }
  lines.push("");
  lines.push("Your advisor's review workflow will check this PR automatically. Merge whenever you're ready.");
  lines.push("");
  lines.push(`— Opened by the m8t platform · release ${s.version}${s.notesUrl ? ` · [release notes](${s.notesUrl})` : ""}`);
  return lines.join("\n");
}
